module.exports = __webpack_public_path__ + "h5/img/bobo.21658f0f.png";